import { api } from "../configs/apiConfig";

const FileService = {
  // Upload a file
  uploadFile: async (file, prefix = "file", destinationPath = null) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      let url = `/file/upload?prefix=${prefix}`;
      if (destinationPath) {
        url += `&destinationPath=${encodeURIComponent(destinationPath)}`;
      }

      const response = await api.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  },

  // Delete a file by file path
  deleteFile: async (filePath) => {
    try {
      const response = await api.delete(`/file/delete?filePath=${encodeURIComponent(filePath)}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting file:", error);
      throw error;
    }
  },
};

export default FileService;
